import React from 'react'
import { Grid } from '@material-ui/core'


/**
 * @param {*} {description}
 * @return {*} 
 * @status no delete
 * @description Simple layout for a description 
 */
const DescriptionTemplatePure = ({ description }) => {
  return (
    <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
      <p style={{ marginBottom: 0 }}>{description}</p>
    </Grid>
  )
}

export { DescriptionTemplatePure as default }
